<div style="margin-top: 20px;">
  <div class="container-tab" style="font-size: small;">
    <div class="container-column-tabs">
      <h3 class="title-main">Consignee</h3>
      <div class="flex-column">
        <div class="row-data">
          <div class="wordwrap text-label" style="font-weight: normal;">{{'UserPages.UserPurchaseOrders.PaymentsPage.ConsigneeNameText' | translate}}:</div>
          <div class="wordwrap text-info" *ngIf="delivery">
            <app-text-preview-tooltip
              [text]="delivery.consigneeCompanyName"
              [maxWidth]="290">
            </app-text-preview-tooltip>
          </div>
        </div>
        <div class="row-data">
          <div class="wordwrap text-label" style="font-weight: normal;">{{'UserPages.UserPurchaseOrders.PaymentsPage.ConsigneeContactNameText' | translate}}:</div>
          <div class="wordwrap text-info" *ngIf="delivery">
            <app-text-preview-tooltip
              [text]="delivery.consigneeContactName"
              [maxWidth]="290">
            </app-text-preview-tooltip>
          </div>
        </div>
        <div class="row-data">
          <div class="wordwrap text-label" style="font-weight: normal;">{{'UserPages.UserPurchaseOrders.PaymentsPage.ConsigneeContactAddressLabel' | translate}}:</div>
          <!--
            <div class="wordwrap text-info">{{delivery?.consigneeContactAddress}}, {{delivery?.consigneeContactCity}}</div>
          -->
          <div class="wordwrap text-info" *ngIf="delivery">
            <app-text-preview-tooltip
              [text]="addressConsignee"
              [maxWidth]="290">
            </app-text-preview-tooltip>
          </div>
        </div>
        <div class="row-data">
          <div class="wordwrap text-label" style="font-weight: normal;">{{'UserPages.UserPurchaseOrders.PaymentsPage.ConsigneeCountryText' | translate}}:</div>
          <div class="wordwrap text-info" *ngIf="delivery">
            <app-text-preview-tooltip
              [text]="delivery.consigneeContactCountry | countryDescription"
              [maxWidth]="290">
            </app-text-preview-tooltip>
          </div>
        </div>
        <div class="row-data">
          <div class="wordwrap text-label" style="font-weight: normal;">{{'UserPages.UserPurchaseOrders.PaymentsPage.ConsigneeEmailText' | translate}}:</div>
          <div class="wordwrap text-info" *ngIf="delivery">
            <app-text-preview-tooltip
              [text]="delivery.consigneeContactEmail"
              [maxWidth]="290">
            </app-text-preview-tooltip>
          </div>
        </div>
      </div>
    </div>
    <div class="container-column-tabs border-lats">
      <h3 class="title-main">Notify</h3>
      <div class="flex-column">
        <div class="row-data">
          <div class="wordwrap text-label" style="font-weight: normal;">{{'UserPages.UserPurchaseOrders.PaymentsPage.NotifyNameText' | translate}}:</div>
          <div class="wordwrap text-info" *ngIf="delivery">
            <app-text-preview-tooltip
              [text]="delivery.notifierCompanyName"
              [maxWidth]="290">
            </app-text-preview-tooltip>
          </div>
        </div>
        <div class="row-data">
          <div class="wordwrap text-label" style="font-weight: normal;">{{'UserPages.UserPurchaseOrders.PaymentsPage.NotifyContactNameText' | translate}}:</div>
          <div class="wordwrap text-info" *ngIf="delivery">
            <app-text-preview-tooltip
              [text]="delivery.notifierContactName"
              [maxWidth]="290">
            </app-text-preview-tooltip>
        </div>
        </div>
        <div class="row-data">
          <div class="wordwrap text-label" style="font-weight: normal;">{{'UserPages.UserPurchaseOrders.PaymentsPage.NotifyContactAddressLabel' | translate}}:</div>
          <!--
            <div class="wordwrap text-info">{{delivery?.notifierContactAddress}}, {{delivery?.notifierContactCity}}</div>
          -->
          <div class="wordwrap text-info" *ngIf="delivery">

            <app-text-preview-tooltip
              [text]="addressNotify"
              [maxWidth]="290">
            </app-text-preview-tooltip>
          </div>
        </div>
        <div class="row-data">
          <div class="wordwrap text-label" style="font-weight: normal;">{{'UserPages.UserPurchaseOrders.PaymentsPage.NotifyCountryText' | translate}}:</div>
          <div class="wordwrap text-info" *ngIf="delivery">
            <app-text-preview-tooltip
              [text]="delivery.notifierContactCountry | countryDescription"
              [maxWidth]="290">
            </app-text-preview-tooltip>
          </div>
        </div>
        <div class="row-data">
          <div class="wordwrap text-label" style="font-weight: normal;">{{'UserPages.UserPurchaseOrders.PaymentsPage.NotifyEmailText' | translate}}:</div>
          <div class="wordwrap text-info" *ngIf="delivery">
            <app-text-preview-tooltip
            [text]="delivery.notifierContactEmail"
            [maxWidth]="290">
          </app-text-preview-tooltip>
          </div>
        </div>
      </div>
    </div>
    <div class="container-column-tabs" *ngIf="importer">
      <h3 class="title-main">Importer</h3>
      <div class="flex-column">
        <div class="row-data">
          <div class="wordwrap text-label" style="font-weight: normal;">{{'UserPages.UserPurchaseOrders.PaymentsPage.ImporterNameText' | translate}}:</div>
          <div class="wordwrap text-info">
            <app-text-preview-tooltip
              [text]="importer.companyName"
              [maxWidth]="290">
            </app-text-preview-tooltip>
          </div>
        </div>
        <div class="row-data">
          <div class="wordwrap text-label" style="font-weight: normal;">{{'UserPages.UserPurchaseOrders.PaymentsPage.NotifyContactNameText' | translate}}:</div>
          <div class="wordwrap text-info">
            <app-text-preview-tooltip
              [text]="importer.contactName"
              [maxWidth]="290">
            </app-text-preview-tooltip>
          </div>
        </div>
        <div class="row-data">
          <div class="wordwrap text-label" style="font-weight: normal;">{{'UserPages.UserPurchaseOrders.PaymentsPage.NotifyContactAddressLabel' | translate}}:</div>
          <div class="wordwrap text-info" *ngIf="this.addressImporter.length>0">
            <!--
              {{importer.contactAddress}}, {{importer.contactCity}}
            -->
              <app-text-preview-tooltip
                [text]="addressImporter"
                [maxWidth]="290">
              </app-text-preview-tooltip>
          </div>
        </div>
        <div class="row-data">
          <div class="wordwrap text-label" style="font-weight: normal;">{{'UserPages.UserPurchaseOrders.PaymentsPage.NotifyCountryText' | translate}}:</div>
          <div class="wordwrap text-info">
            <app-text-preview-tooltip
            [text]="importer.contactCountry | countryDescription"
            [maxWidth]="290">
          </app-text-preview-tooltip>

          </div>
        </div>
        <div class="row-data">
          <div class="wordwrap text-label" style="font-weight: normal;">{{'UserPages.UserPurchaseOrders.PaymentsPage.NotifyEmailText' | translate}}:</div>
          <div class="wordwrap text-info">
            <app-text-preview-tooltip
            [text]="importer.contactEmail"
            [maxWidth]="290">
          </app-text-preview-tooltip>
          </div>
        </div>
      </div>
    </div>
    <!-- <ng-container *ngFor="let exporter of exporters">
      <div class="col-12 md:col-4" style="margin-left: 0px; border-right: 1px solid #bbb; padding-right: 10px;">
        <h3 class="title-main">Exporter</h3>
        <div class="grid">
          <div class="col-12 md:col-6 wordwrap text-label" style="font-weight: normal;">{{'UserPages.UserPurchaseOrders.PaymentsPage.ImporterNameText' | translate}}:</div>
          <div class="col-12 md:col-6 wordwrap text-info">{{exporter.companyName}}</div>
          <div class="col-12 md:col-6 wordwrap text-label" style="font-weight: normal;">{{'UserPages.UserPurchaseOrders.PaymentsPage.NotifyContactNameText' | translate}}:</div>
          <div class="col-12 md:col-6 wordwrap text-info">{{exporter.contactName}}</div>
          <div class="col-12 md:col-6 wordwrap text-label" style="font-weight: normal;">{{'UserPages.UserPurchaseOrders.PaymentsPage.NotifyContactAddressLabel' | translate}}:</div>
          <div class="col-12 md:col-6 wordwrap text-info">{{exporter.contactAddress}}, {{delivery?.notifierContactCity}}</div>
          <div class="col-12 md:col-6 wordwrap text-label" style="font-weight: normal;">{{'UserPages.UserPurchaseOrders.PaymentsPage.NotifyCountryText' | translate}}:</div>
          <div class="col-12 md:col-6 wordwrap text-info">{{exporter.country | countryDescription}}</div>
          <div class="col-12 md:col-6 wordwrap text-label" style="font-weight: normal;">{{'UserPages.UserPurchaseOrders.PaymentsPage.NotifyEmailText' | translate}}:</div>
          <div class="col-12 md:col-6 wordwrap text-info">{{exporter.contactEmail}}</div>
        </div>
      </div>
    </ng-container> -->
  </div>
</div>


